var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toolbar)?_c('div',[(_vm.$vuetify.breakpoint.lgAndUp)?_c('AppToolbarDesktop',{attrs:{"unread-count":_vm.message_unread_count,"approach-unread-count":_vm.approachUnreadCount,"gtm-params":_vm.gtmParams}}):_c('AppToolbarMobile')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }